import { liteClient } from 'algoliasearch/lite';
import type { Listing } from '../api';

const APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID || 'NC39OBLGG3';
const API_KEY = process.env.REACT_APP_ALGOLIA_API_KEY || 'dc77e2a6d622659fd216427832b00f1d';
const INDEX_NAME = process.env.REACT_APP_ALGOLIA_INDEX || 'listings';

export const algoliaClient = liteClient(APP_ID, API_KEY);

export interface AlgoliaHit {
  objectID: string;
  id?: number;
  title?: string;
  description?: string;
  category?: string;
  store?: string;
  price?: number;
  condition?: string;
  image_url?: string | null;
  delivery_time_option?: string;
}

export interface AlgoliaSearchResult {
  hits: AlgoliaHit[];
  page: number;
  nbPages: number;
  nbHits: number;
}

function escapeFacetValue(value: string): string {
  return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

export async function searchAlgoliaListings(options: {
  query: string;
  category?: string;
  page?: number;
  hitsPerPage?: number;
}): Promise<AlgoliaSearchResult> {
  const filterParts: string[] = [];
  if (options.category) {
    filterParts.push(`category:"${escapeFacetValue(options.category)}"`);
  }

  const response = await algoliaClient.search({
    requests: [
      {
        indexName: INDEX_NAME,
        query: options.query,
        page: options.page ?? 0,
        hitsPerPage: options.hitsPerPage ?? 24,
        ...(filterParts.length ? { filters: filterParts.join(' AND ') } : {}),
      } as any,
    ],
  });

  const first = response.results?.[0] as any;
  return {
    hits: first?.hits ?? [],
    page: first?.page ?? 0,
    nbPages: first?.nbPages ?? 0,
    nbHits: first?.nbHits ?? 0,
  };
}

export function algoliaHitToListing(hit: AlgoliaHit): Listing {
  const id = hit.id ?? parseInt(hit.objectID, 10);
  return {
    id,
    title: hit.title ?? '',
    description: hit.description ?? '',
    price: hit.price ?? 0,
    category: hit.category ?? 'general',
    image_url: hit.image_url ?? null,
    user_id: 0,
    city_id: 0,
    state_id: 0,
    seller_name: hit.store ?? '',
    state_name: '',
    state_abbreviation: '',
    city_name: '',
    created_at: '',
    quantity: 1,
    condition: (hit.condition as Listing['condition']) ?? 'new',
    delivery_time_option: hit.delivery_time_option,
  };
}

export function matchesItemType(category: string | undefined, itemType: string): boolean {
  const cat = category || 'general';
  if (itemType === 'food') return cat === 'food' || cat === 'shop';
  if (itemType === 'other') return cat !== 'food' && cat !== 'shop';
  return true;
}
